/// <reference path="Utilities/_reference.ts" />

module YVR.Global {
	// Dependencies
	import dom = YVR.Utilities.DOM;
	import events = YVR.Utilities.Events;

	// Cache jQuery elements
	const elements = {
		body: $('body'),
		panels: $('.yvr-panel--animation'),
		window: $(window)
	};


	/**
	 * The main initializaiton of the global module.
	 */
	function main() {
		initPrivacyBanner();
		eventBindings();
		shortcodeOverlaps();
		financialFigureClearing();
	}

	/**
	 * Set the various global event bindings.
	 */
	function eventBindings() {
		setElementLinks();
		setFormPanelResize();
		setPanelAnimationClasses();
	}

	/**
	 * Allow elements that are not anchors to link to other pages.
	 */
	function setElementLinks() {
		elements.body.on('click', '[data-href]', function (e) {
			window.location.href = $(this).data('href');
		});
	}


	/**
	 * Resize the form panels based on the content.
	 */
	function setFormPanelResize() {
		elements.window.on('resize', events.throttle(formPanelResize, events.DEBOUNCE_INTERNVAL));

		formPanelResize();
	}

	function formPanelResize() {
		$('.yvr-panel--form').each((index, element) => {
			const form = $(element);
			const content = form.find('.yvr-panel__content');
			const overlay = form.find('.yvr-panel__overlay');

			const padding = overlay.css(['paddingBottom', 'paddingTop']);
			const paddingBottom = parseInt((padding as any).paddingBottom.replace('px', ''), 10);
			const paddingTop = parseInt((padding as any).paddingTop.replace('px', ''), 10);

			const height = content.height() + paddingBottom + paddingTop;
			
			overlay.css('min-height', height);
			if (overlay.outerHeight() != 0) {
				form.css('min-height', overlay.outerHeight());
			}
			
		});
	}


	/**
	 * Run the animate function on scroll.
	 */
	function setPanelAnimationClasses() {
		elements.window.on('scroll', events.throttle(animatePanel, events.DEBOUNCE_INTERNVAL));

		animatePanel();
	}


	/**
	 * Add the animate panel if they are in view.
	 */
	function animatePanel() {
		const offset = 150;

		// Loop through all the panels and check their offsets
		elements.panels.each((index, element) => {
			const panel = $(element);
			const rect = element.getBoundingClientRect();

			// Get the padding offset so elements with larger paddings will not animate before the
			// text is in view.
			const paddingOffsetValue = panel.find('.yvr-panel__overlay').css('padding-top').replace('px', '');
			const paddingOffset = parseInt(paddingOffsetValue, 10);

			if (rect.top <= window.innerHeight - paddingOffset - offset) {
				panel.addClass('yvr-panel--animation-start');

				elements.panels = elements.panels.not(element);
			}
		});
	}


	/***
	 * Check shortcodes to see if they overlap other work.
	 */
	function shortcodeOverlaps() {
		const shortcodes = $('.yvr-rte').find('.yvr-shortcode');
		const asideElements = $('.yvr-column--aside').find('.yvr-author, .yvr-socials--share');

		shortcodes.each((shortcodeIndex, shortcode) => {
			const $this = $(shortcode);
			const caption = $this.find('.yvr-media__caption').get(0);

			asideElements.each((asideIndex, aside) => {
				if (dom.isOverlapped(shortcode, aside) || (caption && dom.isOverlapped(caption, aside))) {
					$this.addClass('yvr-shortcode--overlap');
				}
			});

			$this.addClass('yvr-shortcode--loaded');
		});
	}


	/**
	 * Add a class name to financial figures that need to be on a new line by looking
	 * at their previous sibling elements.
	 */
	function financialFigureClearing(): void {
		const blockClassName = 'yvr-financial-figure';
		const figures = $(`.${blockClassName}`);
		const columns = $('.yvr-page--standard').length ? 2 : 3;

		figures.each((index, _figure) => {
			const figure = $(_figure);

			// Check if the figure is already in a container
			if (!figure.parent().hasClass('yvr-financial-figure-column')) {
				let next = figure;
				let collection = figure;

				// Loop through the amount of columns
				for (let i = 0; i < columns - 1; i++) {
					next = next.next();

					// If the figure has another figure after it...
					if (figures.index(next) > -1) {
						collection = collection.add(next);
					}
				}

				// Wrap the collection of elements with a column and a row
				collection
					.wrapAll('<div class="yvr-financial-figure-row"></div>')
					.wrap('<div class="yvr-financial-figure-column"></div>');
			}
		});
	}

	function initPrivacyBanner() {
		const hasShown = YVR.Utilities.Cache.getItem('PrivacyBannerShown');
		const bannerElement = document.querySelector('.yvr-cookies');

		if (bannerElement instanceof HTMLElement) {

			if (!hasShown) {
				bannerElement.style.display = 'block';
				const closePrivacy = document.querySelector('.yvr-cookies__close');
				YVR.Utilities.Cache.setItem('PrivacyBannerShown', true, 43800);

				closePrivacy.addEventListener('click', () => { bannerElement.style.display = 'none'; });
			}
		}
	}

	// Kick it
	main();
}
